import {
  SET_PRACTICE_PATIENTS,
  SET_CODES,
  CLEAR_DASHBOARD,
  SET_PATIENT_SEARCH,
  SET_PROVIDERS,
  SET_DOCUMENT_TYPE,
  CHANGE_DASHBOARD_FILTER,
  SET_REPORT_TYPE,
  SET_PENDING_DOCUMENTS,
  SET_ALL_DOCUMENTS,
  SET_INS_CAR_NAME,
  SET_DIAGNOSIS,
  SET_PROCEDURE,
  SET_MODIFIER,
  SET_PAYER_DASHBOARD,
  SWITCH_CHARGE_ENTRY_VIEW,
  ADD_DOCUMENT_TAGS,
  SET_ADV_DOCUMENT_SEARCH,
  RESET_ADV_DOCUMENT_SEARCH,
  CHANGE_DOCUMENT_FILTER,
  CHANGE_DOCUMENT_SORT,
  SET_PRACTICE_LOC,
} from "../actions/actionTypes";

const initialState = {
  practice_patients: {},
  practice_diagnosis: [],
  practice_procedures: [],
  patient_search: [],
  providers: [],
  payer: [],
  all_documents: [],
  pending_documents: [],
  document_types: [],
  report_types: [],
  dashboardFilter: null,
  documentFilter: null,
  documentSort: null,
  document_tags_for_practice: [],
  adv_doc_search: null,
  // data fetched for dropdown:
  ins_car_name: [],
  diagnosis: [],
  procedure: [],
  modifier: [],
  showNewChargeEntries: false,
  practiceLocation: [],
};

const dasboardReducer = (state = { ...initialState }, action) => {
  switch (action.type) {
    case SET_PRACTICE_PATIENTS:
      console.log(action);
      return {
        ...state,
        practice_patients: action.patients,
      };
    case SET_CODES:
      return {
        ...state,
        practice_diagnosis: action.diagnosis,
        practice_procedures: action.procedure,
      };
    case CLEAR_DASHBOARD:
      return {
        ...initialState,
      };
    case SET_PATIENT_SEARCH:
      return {
        ...state,
        patient_search: action.payload,
      };
    case SET_PROVIDERS:
      return {
        ...state,
        providers: action.providers,
      };
    case SET_DOCUMENT_TYPE:
      return {
        ...state,
        document_types: action.types,
      };
    case CHANGE_DASHBOARD_FILTER:
      return {
        ...state,
        dashboardFilter: action.filter,
      };
    case CHANGE_DOCUMENT_FILTER:
      return {
        ...state,
        documentFilter: action.filter,
      };
    case CHANGE_DOCUMENT_SORT:
      return {
        ...state,
        documentSort: action.sort,
      };
    case SET_REPORT_TYPE:
      return {
        ...state,
        report_types: action.types,
      };
    case SET_PENDING_DOCUMENTS:
      return {
        ...state,
        pending_documents: action.documents,
      };
    case SET_PRACTICE_LOC:
      return {
        ...state,
        practiceLocation: action.practiceLocation,
      };
    case SET_ALL_DOCUMENTS:
      return {
        ...state,
        all_documents: action.documents,
      };
    case SET_DIAGNOSIS:
      return {
        ...state,
        diagnosis: action.diagnosis,
      };
    case SET_PROCEDURE:
      return {
        ...state,
        procedure: action.procedure,
      };
    case SET_INS_CAR_NAME:
      return {
        ...state,
        ins_car_name: action.ins_car_name,
      };
    case SET_MODIFIER:
      return {
        ...state,
        modifier: action.modifier,
      };
    case SET_PAYER_DASHBOARD:
      return {
        ...state,
        payer: action.payload,
      };
    case SWITCH_CHARGE_ENTRY_VIEW:
      return {
        ...state,
        showNewChargeEntries: action.payload,
      };
    case ADD_DOCUMENT_TAGS:
      return {
        ...state,
        document_tags_for_practice: action.payload,
      };
    case SET_ADV_DOCUMENT_SEARCH:
      return {
        ...state,
        adv_doc_search: action.payload,
      };
    case RESET_ADV_DOCUMENT_SEARCH:
      return {
        ...state,
        adv_doc_search: null,
      };
    default:
      return state;
  }
};

export default dasboardReducer;
